;
(function ($) {
  var dataKey = 'app.time-converter';
  var TimeConverter = function TimeConverter(element, options) {
    this.element = element;
    this.init(options);
  };
  TimeConverter.prototype = {
    attr: {
      trigger: 'data-to-local-time'
    },
    /**
     * Initialise TimeConverter
     * Sets the time of last logged in to the correct timezone (clients time zone)
     * @public
     * @constructor
     * @param {string} options - Apply and extend options into init if needed.
     */

    init: function init(options) {
      $.extend(this.options, options);
      var $timeConverterTrigger = this._getTimeConverterTrigger();
      var dateFormat = options.dateFormat;
      var utcTime = $timeConverterTrigger.prevObject.html();
      $timeConverterTrigger.prevObject.html(this.convertUtcTimeToLocalTime(utcTime, dateFormat));
    },
    /**
     * Get Time Converter trigger
     * Returns Time Converter trigger element.
     * @private
     */

    _getTimeConverterTrigger: function _getTimeConverterTrigger() {
      return this.element.find('[' + this.attr.trigger + ']');
    },
    /**
     * Convert UTC to clients local time
     * @public
     * @param {param} time : UTC time to convert.
     * @param {param} dateFormat : String specifying date format to read and return
     * @returns Local time in the format specified in options
     */
    convertUtcTimeToLocalTime: function convertUtcTimeToLocalTime(time, dateFormat) {
      var utcMoment = moment.utc(time, dateFormat);
      var localMoment = moment(utcMoment).local();
      return localMoment.format(dateFormat);
    }
  };

  /**
   * Global callback function which by default all [data-to-local-time] triggers this plugin.
   * @method $.fn.app_timeConverter()
   * @public
   * @constructor
   * @param {string} options
   * @optional options
   * @example $(element).app_timeConverter();
   */

  $.fn.app_timeConverter = function (options) {
    var plugin = this.data(dataKey);
    if (plugin instanceof TimeConverter) {
      if (typeof options !== 'undefined') {
        plugin.init(options);
      }
    } else {
      plugin = new TimeConverter(this, options);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);